import { Breadcrumb as BSBreadcrumb } from "react-bootstrap";
import { BreadCrumbItemModel, BreadCrumbModel } from "./breadcrumbModel";
import { Link } from "react-router-dom";

export const Breadcrumb = ({ children }: BreadCrumbModel) => {
  return (
    <div className="breadcrumb-wrapper">
      <BSBreadcrumb>
        <BreadCrumbItem to="/">Home</BreadCrumbItem>
        {children}
      </BSBreadcrumb>
    </div>
  );
};

export const BreadCrumbItem = ({ to, children }: BreadCrumbItemModel) => {
  if (to === undefined) {
    return <a className="breadcrumb-item active">{children}</a>;
  }

  return (
    <Link to={to} className="breadcrumb-item">
      {children}
    </Link>
  );
};
